import { object, string } from "yup";

export const EmailValidation = (t) =>
  object().shape({
    email: string().required(t("emailIsRequired")).email(t("emailError")),
  });

export const CommentValidation = (t) =>
  object().shape({
    comment: string().required(t("commentRequired")),
  });
